import React, {Fragment, useEffect, useRef, useState} from "react";
import {Grid, AutoSizer} from "react-virtualized";
import PropTypes from "prop-types";
import {connect} from "react-redux";

import SelectionGridFiltersTitle from "./selectionGridFiltersTitle";
import SelectionGridItem from "./selectionGridItem";
import {shiftFilterTitleInterface} from "../../../interfaces/shiftFilterTitleInterface";
import {getFilterGroupValues} from "../../../misc/utils";

const SelectionMainVirtualizedFiltersGrid = (props) => {

  const {currentFeatures, handleFeatureClick, handleUserLoginClick, listItemHeight, onScroll, selectionWindowView,
    checkIfFeatureSelected, scrollElement, currentParent, filterGroups} = props;

  const [currentFilter, setCurrentFilter] = useState(null);
  const [defaultTitle, setDefaultTitle] = useState(null); // never changes, is needed for arrows only
  const [gridFeatures, setGridFeatures] = useState([]);
  const [allTitles, setAllTitles] = useState([]);
  const [reversedTitles, setReversedTitles] = useState([]);
  const filtersGrid = useRef(null);

  const materialFilterGroup = filterGroups.find(filterGroup => filterGroup.name.trim() === "Countertop Material");
  const filterValuesAvailable = materialFilterGroup.values.filter(filterValue => {
    return currentParent.filtersReceived.includes(filterValue.id)
  })
  // console.log("filterValuesAvailable", filterValuesAvailable);
  const columnCount = selectionWindowView + 2; // for ex. 1,2,3 view -> 3,4,5 columns

  useEffect(() => {
    const {firstTitle} = getFeaturesAndFirstTitle();
    setCurrentFilter(Object.assign({}, firstTitle));
    setDefaultTitle(Object.assign({}, firstTitle));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  useEffect(() => {
    const {renderFeatures} = getFeaturesAndFirstTitle();
    setGridFeatures([...renderFeatures]);
    let newAllTitles = [defaultTitle, ...renderFeatures]
      .filter(renderFeature => renderFeature && (renderFeature.type === "filter_header"))
      .map(renderFeature => {
        const {rowIndex, titleIndex} = renderFeature;
        // const {scrollTop} = filtersGrid.current.getOffsetForCell({columnIndex: 0, rowIndex})
        const skipTitles = titleIndex - 1;
        const titleShift = skipTitles > 0
          ? (skipTitles * 45) - (skipTitles * (listItemHeight + 5))
          : 0
        const scrollTop = rowIndex * (listItemHeight + 5) + titleShift;
        return {...renderFeature, scrollTop}
      })
    // console.log("newAllTitles", newAllTitles);
    setAllTitles([...newAllTitles]);
    setReversedTitles([...newAllTitles.reverse()]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [defaultTitle, currentFeatures.length, listItemHeight, selectionWindowView, currentParent.partId])

  const getFeaturesAndFirstTitle = () => {
    let renderFeatures = [];
    let titleIndex = 0;
    let firstTitle = null;

    for (let k = 0; k < filterValuesAvailable.length; k++) {
      const filterValue = filterValuesAvailable[k];
      const countertopsFiltered = currentFeatures.filter(feature => {
        if (!feature) {
          return false
        }
        const countertopFilters = getFilterGroupValues(feature.part, materialFilterGroup);
        return countertopFilters && countertopFilters.includes(filterValue.id)
      });
      if (countertopsFiltered.length) {
        const title = {
          titleIndex,
          scrollTop: 0,
          // scrollTop: (Math.ceil(renderFeatures.length / columnCount) * (listItemHeight + 5)) + titleSkip,
          filterValue,
          type: "filter_header",
          rowIndex: Math.ceil(renderFeatures.length / columnCount) // next one
        }
        if (!firstTitle) {
          firstTitle = title
        } else {
          const spacersCount = columnCount - (renderFeatures.length % columnCount);
          if (spacersCount !== columnCount) {
            for (let i = 0; i < spacersCount; i++) {
              renderFeatures.push({type: "spacer"})
            }
          }
          const spacersTitleCount = columnCount - 1; // 1 is title
          renderFeatures.push(title)
          for (let i = 0; i < spacersTitleCount; i++) {
            renderFeatures.push({type: "spacer"})
          }
        }
        renderFeatures = [...renderFeatures, ...countertopsFiltered];
        titleIndex++;
      }
    }
    const rowsToAdd = Math.floor(scrollElement.clientHeight / (listItemHeight + 5));
    for (let i = 0; i < (columnCount * rowsToAdd); i++) { // adding additional spacers
      const check = renderFeatures[renderFeatures.length - 1 - i];
      if (check && (check.type === "filter_header" || check.type === "spacer")) {
        for (let j = 0; j < (columnCount * rowsToAdd); j++) {
          renderFeatures.push({type: "empty-spacer"})
        }
        break;
      }
    }
    return {renderFeatures, firstTitle}
  }

  // console.log("allTitles render", allTitles);
  // console.log("reversedTitles render", reversedTitles);

  const onGridScroll = (props) => {
    const {scrollTop} = props;
    // console.log("scrollTop", scrollTop);
    for (let i = 0; i < reversedTitles.length; i++) {
      const shiftTitle = reversedTitles[i];
      if (!scrollTop) {
        const firstT = reversedTitles[reversedTitles.length - 1]
        if (shiftTitle.filterValue.id !== firstT.filterValue.id) {
          setCurrentFilter(Object.assign({}, firstT))
        }
        break;
      } else if (scrollTop > shiftTitle.scrollTop) {
        if (shiftTitle.filterValue.id !== currentFilter.filterValue.id) {
          setCurrentFilter(Object.assign({}, shiftTitle))
        }
        break;
      }
    }
    onScroll(props)
  };

  const cellRenderer = ({columnIndex, key, rowIndex, style}) => {
    let index = (columnCount * rowIndex) + columnIndex;
    if (!gridFeatures[index]) {
      return null
    } else if (gridFeatures[index].type === "filter_header") {
      return <SelectionGridFiltersTitle style={style}
                                        filterTitle={gridFeatures[index]}
                                        key={key}
                                        allTitles={allTitles}
                                        filtersGrid={filtersGrid}/>
    } else if (gridFeatures[index].type === "spacer") {
      return <div className="empty-spacer" style={Object.assign({} , style, {height: 30})} key={key}/>
    } else if (gridFeatures[index].type === "empty-spacer") {
      return <div className="empty-spacer" style={style} key={key}/>
    }
    return (
      <div key={key} style={style}>
        <SelectionGridItem
          styles={{
            height: listItemHeight
          }}
          currentFeature={gridFeatures[index]}
          checkIfFeatureSelected={checkIfFeatureSelected}
          handleFeatureClick={handleFeatureClick}
          handleUserLoginClick={handleUserLoginClick}
        />
      </div>
    )
  }

  const getRowHeight = (props) => {
    const {index} = props;
    const firstRowFeatureIndex = columnCount * index;
    const element = gridFeatures[firstRowFeatureIndex];
    if (element && (element.type === "spacer" || element.type === "filter_header")) {
      return 45
    }
    return listItemHeight + 5
  }

  return (
    <Fragment>
      {currentFilter ? (
        <SelectionGridFiltersTitle filterTitle={currentFilter}
                                   allTitles={allTitles}
                                   isTopTitle={true}
                                   filtersGrid={filtersGrid}/>
      ) : null}
      <AutoSizer>
        {/*{({ height, isScrolling, onChildScroll, scrollTop, width }) => (*/}
        {() => {
          const width = scrollElement.clientWidth || 0;
          const height = scrollElement.clientHeight || 0;
          return (
            <Grid rowCount={Math.ceil(gridFeatures.length / columnCount)}
                  ref={filtersGrid}
                  columnCount={columnCount}
                  width={width}
                  height={height}
                  onScroll={onGridScroll}
                  columnWidth={(width / columnCount) - 2}
                  rowHeight={getRowHeight}
                  overscanRowCount={5}
                  cellRenderer={cellRenderer}>
            </Grid>
          )
        }}
      </AutoSizer>
    </Fragment>
  )
}

SelectionMainVirtualizedFiltersGrid.propTypes = {
  currentFeatures: PropTypes.array,
  handleFeatureClick: PropTypes.func.isRequired,
  handleUserLoginClick: PropTypes.func.isRequired,
  checkIfFeatureSelected: PropTypes.func.isRequired,
  onScroll: PropTypes.func,
  currentParent: PropTypes.object.isRequired,
  listItemHeight: PropTypes.number,
  scrollElement: PropTypes.any, // div
  firstFilterTitle: PropTypes.shape(shiftFilterTitleInterface)
}

const mapStateToProps = (store) => {
  const {selectionWindowView} = store.selectionState;
  return {
    selectionWindowView,
    filterGroups: store.filterState.filterGroups,
  };
};

const mapDispatchToProps = {

};

export default connect(mapStateToProps, mapDispatchToProps)(SelectionMainVirtualizedFiltersGrid)
